import { system } from 'styled-system';
import { getColor } from '../internal';

const config = {
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors',
    transform: getColor,
  },
  bg: {
    property: 'backgroundColor',
    scale: 'colors',
    transform: getColor,
  },
};

export default system(config);
